
export async function register(credentials) {
    let response;

    try{
        response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(credentials)
        });
    }catch(error){
        throw new Error('Registration failed');
    }   

    if (!response.ok) {
        const errorMessage = await response.json();
        throw new Error(errorMessage.message || 'Registration failed');
    }
    const data = await response.json();
    if(data.token){
        localStorage.setItem('authenticationToken', data.token);
    }
    if(data.user){
        localStorage.setItem('userEmbeddings', JSON.stringify(data.user));
    }
    return data.message;
}



export async function login(credentials) {
    let response;

    try{
        response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(credentials)
        });
    }catch(error){
        throw new Error('Login failed');
    }   

    if (!response.ok) {
        const errorMessage = await response.json();
        throw new Error(errorMessage.message || 'Login failed');
    }
    const data = await response.json();
    localStorage.setItem('authenticationToken', data.token);
    localStorage.setItem('userEmbeddings', JSON.stringify(data.user));
    return true;

}


export async function refreshToken() {
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/refresh-token`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('authenticationToken')}`
            }
        });
        if (!response.ok) {
            localStorage.removeItem('authenticationToken');
            return false;
        }
        const data = await response.json();
        localStorage.setItem('authenticationToken', data.token);
        localStorage.setItem('userEmbeddings', JSON.stringify(data.user));
        return true;
    } catch (error) {
        localStorage.removeItem('authenticationToken');
        return false;
    }
}
